<script setup lang="ts">
const props = defineProps<{
  items: string[] | { name: string; value: string }[]
  modelValue: number | string
  links?: boolean
}>()
const emit = defineEmits(['update:modelValue'])
const tabs = typeof props.items[0] === 'string' ? props.items.map((name, value) => ({ name, value })) : props.items as { name: string; value: string | number }[]

function select(value: string | number) {
  emit('update:modelValue', value)
}
</script>

<template>
  <div class="flex overflow-auto border-b-1 border-gray tabs">
    <div v-for="tab in tabs" :key="tab.value" class="pb-2px" :class="{ active: tab.value === modelValue }">
      <StoryblokLink v-if="links" :to="tab.value" class="text-center">
        {{ tab.name }}
      </StoryblokLink>
      <div v-else class="text-center" @click="select(tab.value)">
        {{ tab.name }}
      </div>
    </div>
  </div>
</template>

  <style scoped lang="scss">
  .tabs {
    & > div > * {
      @apply rounded-lg hover:bg-primary/15 hover:text-primary px-2 sm:px-4 py-1 cursor-pointer;
    }
    & > .active {
      @apply border-b-2 text-primary border-primary;
    }
  }
  </style>
